import { render, staticRenderFns } from "./DestinationOfCoverage.vue?vue&type=template&id=4faa91e3"
import script from "./DestinationOfCoverage.vue?vue&type=script&lang=js"
export * from "./DestinationOfCoverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports